import { useState, type ChangeEvent } from 'react';

import { Box, Typography } from '@mui/material';

type EmailSubjectInputProps = {
    subject: string;
    onChange: (subject: string) => void;
}

export default function EmailSubjectInput({ subject, onChange }: EmailSubjectInputProps) {
  const [inputValue, setInputValue] = useState(subject);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const handleBlur = () => {
    if (inputValue.trim()) {
      onChange(inputValue);
    }
  };
    
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 1,
          padding: '8px 16px',
          border: '1px solid #D9D9D9',
          borderRadius: '8px',
          transition: 'background-color 0.2s ease',
        }}
      >
        <Typography
          sx={{
            fontSize: 16,
            color: '#F69C2C',
            fontWeight: 500,
            lineHeight: '34px',
          }}
        >
          Subject:
        </Typography>

        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleBlur}
          placeholder="Subject"
          style={{
            border: 'none',
            outline: 'none',
            backgroundColor: 'transparent',
            fontSize: '16px',
            padding: 0,
            lineHeight: '34px',
            flex: '1 1 0%',
            color: 'hsl(var(--foreground))',
            fontFamily: 'inherit',
          }}
        />
      </Box>
    </Box>
  );
}
